import { useMemo } from 'react';
import { EEthereumNetworkId } from '@ankr.com/provider';

import { globalTranslation, useTranslation } from 'modules/i18n';

import { AVAILABLE_CHAINS, CHAIN_UNIT } from '../consts';
import { getChainIcon, GetChainIconResult } from '../utils/getChainIcon';

export interface UseChainListItem {
  chainId: EEthereumNetworkId;
  name: string;
  icon: GetChainIconResult;
  tokenName: string;
  chainUnit: string;
}

export type UseChainListResult = UseChainListItem[];

const availableChains = new Set(AVAILABLE_CHAINS);

export function useChainList(): UseChainListResult {
  const { t, keys } = useTranslation(globalTranslation);
  return useMemo(
    () =>
      [
        {
          chainId: EEthereumNetworkId.smartchain,
          chainUnit: CHAIN_UNIT[EEthereumNetworkId.smartchain],
          name: t(keys.chains[EEthereumNetworkId.smartchain]),
          icon: getChainIcon(EEthereumNetworkId.smartchain),
          tokenName: t(
            keys.nativeTokenByChainId[EEthereumNetworkId.smartchain],
          ),
        },
        {
          chainId: EEthereumNetworkId.smartchainTestnet,
          chainUnit: CHAIN_UNIT[EEthereumNetworkId.smartchainTestnet],
          name: t(keys.chains[EEthereumNetworkId.smartchainTestnet]),
          icon: getChainIcon(EEthereumNetworkId.smartchainTestnet),
          tokenName: t(
            keys.nativeTokenByChainId[EEthereumNetworkId.smartchainTestnet],
          ),
        },
        {
          chainId: EEthereumNetworkId.polygon,
          chainUnit: CHAIN_UNIT[EEthereumNetworkId.polygon],
          name: t(keys.chains[EEthereumNetworkId.polygon]),
          icon: getChainIcon(EEthereumNetworkId.polygon),
          tokenName: t(keys.nativeTokenByChainId[EEthereumNetworkId.polygon]),
        },
        {
          chainId: EEthereumNetworkId.mumbai,
          chainUnit: CHAIN_UNIT[EEthereumNetworkId.mumbai],
          name: t(keys.chains[EEthereumNetworkId.mumbai]),
          icon: getChainIcon(EEthereumNetworkId.mumbai),
          tokenName: t(keys.nativeTokenByChainId[EEthereumNetworkId.mumbai]),
        },
      ].filter(({ chainId }) => availableChains.has(chainId)),
    [t, keys],
  );
}
